import React from 'react'
import PropTypes from 'prop-types'
import jwt_decode from "jwt-decode";
import { compose, withApollo } from 'react-apollo'
import { message, Card, Button, Row, Form, Input } from 'antd'
import { withFormik } from 'formik'
import * as yup from 'yup'
import { Wrapper, Logo } from './styles'
import API from '../../api/Http'
import * as EndPoints from '../../api/EndPoints'
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import AppleLogin from "react-apple-login";
const logo = require('../../assets/images/logo-inverse.png')


const FormItem = Form.Item

const validationSchema = () => {
  /* istanbul ignore next */
  return yup.object().shape({
    email: yup
      .string()
      .email()
      .required(),
    password: yup.string().required()
  })
}
const responseFacebook = async (response) => {
  try {
    const data = {
      email: response.email,
      facebookId: response.id,
      imageUrl: response.picture.data.url,
      name: response.name,
    }
    const result = await API.post(EndPoints.LOGIN + `/brand/facebook`, data)
    console.log(result.status)
    if (result.status === 200) {
      localStorage.setItem('user-token', result.data.data.token)
      localStorage.setItem('data', JSON.stringify(result.data.data));
      window.location.href = "/";
    }
  } catch (error) {
    message.error("ผิดพลาด กรุณาลองใหม่หรือติดต่อ admin")
    console.log(error)
  }
}

const responseApple = async (response) => {
  try {
    const decoded = jwt_decode(response.authorization.id_token);
    console.log(response);
    const data = {
      appleId: decoded.sub,
    }
    if (response.user) {
      data.name = response.user.name.firstName + " " + response.user.name.lastName,
        data.email = response.user.email
    }
    else {
      data.email = decoded.email,
        data.name = decoded.email
    }
    const result = await API.post(EndPoints.LOGIN + `/brand/apple`, data)
    console.log(result.status)
    if (result.status === 200) {
      localStorage.setItem('user-token', result.data.data.token)
      localStorage.setItem('data', JSON.stringify(result.data.data));
      window.location.href = "/";
    }
  } catch (error) {
    message.error("ผิดพลาด กรุณาลองใหม่หรือติดต่อ admin")
    console.log(error)
  }
}

export const handleSubmit = async (values, { props }) => {
  const { email, password } = values
  const { client } = props

  let result

  try {
    const data = {
      email: email,
      password: password,
    }
    result = await API.post(EndPoints.LOGIN + `/brand`, data)

    if (result.status === 200) {
      localStorage.setItem('user-token', result.data.data.token)
      localStorage.setItem('data', JSON.stringify(result.data.data));
      client.resetStore()
      window.location.href = "/";
    }

  } catch (error) {
    message.error("ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง")
    console.log(error)
  }
}

export const Login = ({
  handleSubmit,
  isValid,
  handleChange,
  handleBlur,
  errors,
  touched
}) => {
  return (
    <React.Fragment>
      <Wrapper>
        <Logo>
          <img
            src={logo}
            alt="logo"
            height={50}
            style={{ width: '66%' }}
          />
        </Logo>
        <Form onSubmit={handleSubmit}>
          <p>ชื่อผู้ใช้งาน Green2Get</p>
          <FormItem
            hasFeedback
            help={touched.email && errors.email}
            validateStatus={touched.email && errors.email && 'error'}
          >
            <Input
              id="email"
              name="email"
              type="email"
              placeholder="Email"
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </FormItem>
          <p>รหัสผู้ใช้งาน</p>
          <FormItem
            help={touched.password && errors.password}
            validateStatus={touched.password && errors.password && 'error'}
          >
            <Input.Password
              id="password"
              name="password"
              type="password"
              placeholder="Password"
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </FormItem>
          <Row>
            <Button htmlType="submit" type="primary" disabled={!isValid}>
              Sign In
            </Button>
          </Row>
        </Form>
        <r>หรือ</r>
        <Row type="flex" justify="center" align="middle">
          <AppleLogin
            clientId="com.green2get.brandweb"
            redirectURI={process.env.REACT_APP_BRABD_ENDPOINT}
            usePopup={true}
            scope="email name"
            responseMode="query"
            callback={responseApple}
            render={renderProps => (
              <button
                onClick={renderProps.onClick}
                style={{
                  backgroundColor: "black",
                  color: "#ffffff",
                  padding: 10,
                  cursor: "pointer",
                  borderRadius: "17px",
                  border: "0px transparent",
                  fontFamily: "Helvetica,sans-serif",
                  fontWeight: "500",
                  height: "50px",
                  width: "300px",
                  fontSize: "15px"
                }}
              >
                 ลงชื่อเข้าด้วย Apple
              </button>
            )}
          />
        </Row>
        <br></br>
        <Row type="flex" justify="center" align="middle">
          <FacebookLogin
            appId="1713596468970890"
            autoLoad={false}
            fields="name,email,picture"
            callback={responseFacebook}
            render={renderProps => (
              <button
                onClick={renderProps.onClick}
                style={{
                  backgroundColor: "#4C69B9",
                  color: "#ffffff",
                  padding: 10,
                  cursor: "pointer",
                  borderRadius: "17px",
                  border: "0px transparent",
                  fontFamily: "Helvetica,sans-serif",
                  fontWeight: "500",
                  height: "50px",
                  width: "300px",
                  fontSize: "15px"
                }}
              >
                เข้าสู่ระบบด้วย Facebook
              </button>
            )}
          />
        </Row>
      </Wrapper>
    </React.Fragment>
  )
}

Login.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired
}
export default compose(
  withApollo,
  withFormik({
    handleSubmit,
    validationSchema,
    displayName: 'LoginForm'
  })
)(Login)



// WEBPACK FOOTER //
// ./src/pages/Login/index.js